import { decodeToken } from "react-jwt";
import { clearGlobalLogoutState } from "./api";

export const DASHBOARD_PATH = "/dashboard";
export const WALKTHROUGH_PATH = "/website-walkthrough";

export const decodeAuthToken = (token) => {
    if (!token) return null;
    return decodeToken(token);
};

export const isFirstTimeLogin = (decodedToken) => {
    return decodedToken?.is_first_time_login === true || decodedToken?.isFirstTimeLogin === true;
};

export const getPostLoginPath = (token) => {
    return isFirstTimeLogin(decodeAuthToken(token)) ? WALKTHROUGH_PATH : DASHBOARD_PATH;
};

export const extractAuthTokens = (payload) => {
    const data = payload?.data?.data || payload?.data || payload || {};

    return {
        token: data.token,
        refresh: data.refresh || data.refreshToken,
    };
};

export const saveAuthTokens = ({ token, refresh }) => {
    clearGlobalLogoutState();
    if (token) localStorage.setItem("token", token);
    if (refresh) {
        localStorage.setItem("refresh", refresh);
        localStorage.setItem("refreshToken", refresh);
    }
};
